import React from "react";

const AboutDevirsityCommitments = () => {
  return (
    <div id="hs_cos_wrapper_widget_1719384527279" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" style={{background:'#fff', justifyContent:'center', width:'100%'}}>
      <style>
        {`
          .text-container {
            padding: 0;
          }

          .editor-wrapper {
            margin: 20px 0;
          }

     

          .editor-wrapper p {
            font-size: 16px;
            line-height: 1.6;
            color: #333;
          }

          .editor-wrapper strong {
            font-weight: bold;
          }

          .editor-wrapper img {
            max-width: 100%;
            height: auto;
          }

          .editor-wrapper img[src*="box-mosule-img.png"] {
            margin-top: 20px;
          }
        `}
      </style>
      <h1 style={{marginLeft:'150px'}}>Diversity,<span style={{color:'rgb(15 128 155)'}}> Equity and Inclusion</span></h1>
      <div className="row text-container widget_1719384527279" style={{width:'100%',justifyContent:"center"}}>
        
        <div className="editor-wrapper">
          <div className="container">
            <p style={{textAlign:'justify'}}>
              Our commitment to diversity, equity and inclusion opens new growth opportunities for individuals from varied backgrounds. A diverse workforce also strengthens our ability to access a broader range of skills, experiences, cultures, and perspectives that foster innovation to meet the broad spectrum of customer needs and accelerate our collective wellbeing and prosperity. We conduct Associate Satisfaction Surveys (ASAT) where the engagement score combines job satisfaction and happiness, purpose is assessed through questions on company culture and goal setting, and stress levels are gauged by inquiring about energy at work.
            </p>
            <p style={{textAlign:'justify'}}>
              As an example, one of our DEI objectives has been to increase our gender ratios, especially in management and executive positions. In 2023, we launched our <strong>Women in Leadership program which</strong> was a combination of development workshops and mentoring. The program will now become a regular part of our development curriculum, and we will continue to increase the number of female associates that participate.
            </p>
            <p>
              <img 
                src="#"
                width="1919"
                height="500"
                loading="lazy"
                alt="box-mosule-img"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDevirsityCommitments;
